// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lumineon: PokeData = {
  "id": 457,
  "name": "lumineon",
  "height": 12,
  "weight": 240,
  "base_experience": 161,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "pound",
    "gust",
    "water-gun",
    "hydro-pump",
    "bubble",
    "flail",
    "attract",
    "safeguard",
    "rain-dance",
    "whirlpool",
    "silver-wind",
    "bounce",
    "water-pulse",
    "roost",
    "tailwind",
    "u-turn",
    "aqua-ring",
    "air-slash",
    "captivate",
    "soak"
  ],
  "moves": [
    "gust",
    "hydro-pump",
    "bubble",
    "rain-dance",
    "whirlpool",
    "roost",
    "tailwind",
    "air-slash",
    "bubble-beam",
    "life-dew",
    "aqua-cutter",
    "water-spout",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 237,
    "item": null,
    "species": [
      {
        "name": "finneon",
        "order": 476,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lumineon",
        "order": 477,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 456,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 31,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 128,
    "speed": 155,
    "ability_power": 117
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
